import React from "react";
import styled from "styled-components";
import { color, font } from "../templates/ui";
import FormActions from "../molecules/FormActions";
const Container = styled.div `
    background-color: ${color.body.base};
    box-shadow: 0 0 20px rgba(26, 26, 33, 0.11);
    border-radius: ${(props) => {
    if (props.hasFooterActions) {
        return "10px 10px 0 0";
    }
    return "10px";
}};
    padding: 20px;
    margin-bottom: ${(props) => {
    if (props.hasFooterActions) {
        return "0";
    }
    return "30px";
}};

    @media only screen and (min-width: 768px) {
        padding: 30px;
    }
`;
const StyledMandatoryText = styled.div `
    color: ${color.gray.dark};
    font-style: italic;
    font-size: ${font.small};
`;
const StyledMandatoryIndicator = styled.span `
    color: ${(props) => props.theme.primary};
`;
const ContentContainer = ({ children, hasMandatoryExplanationText, hasFooterActions, backButtonHandle, hasNextButtonIconRight, hasNextButtonIconLeft, buttonFullWidth, nextButtonIcon, nextButtonText, loading, }) => (React.createElement(React.Fragment, null,
    React.createElement(Container, { hasFooterActions: !!hasFooterActions },
        children,
        hasMandatoryExplanationText && (React.createElement(StyledMandatoryText, null,
            "Velden met een",
            " ",
            React.createElement(StyledMandatoryIndicator, null, "*"),
            " zijn verplicht."))),
    hasFooterActions && (React.createElement(FormActions, { nextButtonText: nextButtonText, nextButtonIcon: nextButtonIcon, buttonFullWidth: buttonFullWidth, hasNextButtonIconRight: hasNextButtonIconRight, hasNextButtonIconLeft: hasNextButtonIconLeft, backButtonHandle: backButtonHandle, loading: loading }))));
export default ContentContainer;
